import { FC, useMemo } from 'react';

import {
  CalendarIllustrationIcon,
  EnvelopeIcon,
  ErrorIllustrationIcon,
  FolderIllustrationIcon,
  FolderWithFileIcon,
  LayersIcon,
  MessagesIcon,
  NotFoundIllustrationIcon,
  PencilIcon,
  UsersIllustrationIcon,
} from '../../../assets/icons';

export type IllustrationVariant =
  | 'notFound'
  | 'folder'
  | 'envelope'
  | 'calendar'
  | 'layers'
  | 'pencil'
  | 'messages'
  | 'folder-with-file'
  | 'users'
  | 'error';

type IllustrationsProps = {
  variant: IllustrationVariant;
};

export const Illustrations: FC<IllustrationsProps> = ({ variant }) => {
  return useMemo(() => {
    switch (variant) {
      case 'notFound': {
        return <NotFoundIllustrationIcon />;
      }
      case 'folder': {
        return <FolderIllustrationIcon />;
      }
      case 'envelope': {
        return <EnvelopeIcon />;
      }
      case 'calendar': {
        return <CalendarIllustrationIcon />;
      }
      case 'layers': {
        return <LayersIcon />;
      }
      case 'pencil': {
        return <PencilIcon />;
      }
      case 'messages': {
        return <MessagesIcon />;
      }
      case 'folder-with-file': {
        return <FolderWithFileIcon />;
      }
      case 'users': {
        return <UsersIllustrationIcon />;
      }
      case 'error': {
        return <ErrorIllustrationIcon />;
      }
    }
  }, [variant]);
};
